import type { RatingCardFragmentFragment } from '@packages/gql/generated/shopping/graphql';

export type RatingCardTagsProps = {
  /**
   * data - the data needed to render the component
   */
  data:
    | NonNullable<NonNullable<RatingCardFragmentFragment['reviewTags']>['proTags']>
    | NonNullable<NonNullable<RatingCardFragmentFragment['reviewTags']>['contraTags']>;
  /**
   * label - the label that is placed before the tags
   */
  label: string;
};

/**
 * The RatingCardTag component displays the rating pro and/or contra tags
 */
export const RatingCardTags = ({ data, label, ...props }: RatingCardTagsProps) => (
  <div
    className="text-size-body2"
    {...props}
  >{`${label} ${data.map((tag) => tag.name).join(', ')}`}</div>
);
